var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-w-full"},[_c('div',[_c(_vm.returnActiveHeadbar,{tag:"component"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }